/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomDatepickerParseFormatter extends NgbDateParserFormatter {
  isNumber(value: any): value is number {
    return !Number.isNaN(this.toInteger(value));
  }

  toInteger(value: any): number {
    return Number.parseInt(`${value}`, 10);
  }

  padNumber(value: number) {
    return this.isNumber(value) ? `0${value}`.slice(-2) : '';
  }

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: Number.parseInt(date[0], 10),
        month: Number.parseInt(date[1], 10),
        year: Number.parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? this.padNumber(date.day) + this.DELIMITER + this.padNumber(date.month) + this.DELIMITER + date.year
      : '';
  }

  /* parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('-');
      if (dateParts.length === 1 && this.isNumber(dateParts[0])) {
        return {
          day: this.toInteger(dateParts[0]),
          month: new Date().getMonth(),
          year: new Date().getFullYear(),
        };
      } else if (dateParts.length === 2 && this.isNumber(dateParts[0]) && this.isNumber(dateParts[1])) {
        return {
          day: this.toInteger(dateParts[0]),
          month: this.toInteger(dateParts[1]),
          year: 0,
        };
        // eslint-disable-next-line max-len
      } else if (
        dateParts.length === 3 &&
        this.isNumber(dateParts[0]) &&
        this.isNumber(dateParts[1]) &&
        this.isNumber(dateParts[2])
      ) {
        // eslint-disable-next-line max-len
        return {
          day: this.toInteger(dateParts[0]),
          month: this.toInteger(dateParts[1]),
          year: this.toInteger(dateParts[2]),
        };
      }
    }
    return {
      day: new Date().getDate(),
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };
  }

  format(date: NgbDateStruct): string {
    // eslint-disable-next-line max-len
    return date
      ? `${this.isNumber(date.day) ? this.padNumber(date.day) : ''}/${
          this.isNumber(date.month) ? this.padNumber(date.month) : ''
        }/${date.year}`
      : '';
  } */
}
